import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { otpApiReq } from "../../redux/auth/actions";
import _ from "lodash";

const EmailVerifiedSuccess = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const email = params.get('email');
    const userId = params.get('userId');
    const token = params.get('token');
    const from = params.get('from');

    const otpRes = useSelector((state) => state.auth.otpRes);

    const [isLoading,setIsLoading] = useState(false);

    useEffect(()=>{
        if(from==="email"&&!_.isEmpty(token)){
            setIsLoading(true);
            dispatch(
                otpApiReq({
                  module: "otpApiReq",
                  postData: {
                    user_id: "",
                    verify_token: "",
                    token:token,
                    type:"email"
                  }
                })
              );
        }
    },[from])

    useEffect(() => {
        if (!_.isEmpty(otpRes)) {
          setIsLoading(false)
          
        }
      }, [otpRes])

    return (<>
        <Loader start={isLoading} />
        <div className="col-xl-5 col-lg-6 col-sm-12 col-12 ttxt">
            <div className="icon-box text-center">
                <svg
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g filter="url(#filter0_d_3752_2008)">
                        <rect x="2" y="1" width="56" height="56" rx="12" fill="white" />
                        <rect
                            x="2.5"
                            y="1.5"
                            width="55"
                            height="55"
                            rx="11.5"
                            stroke="#EAECF0"
                        />
                        <path
                            d="M18.334 23.1641L27.8597 29.8321C28.6311 30.372 29.0168 30.642 29.4363 30.7466C29.8069 30.839 30.1944 30.839 30.565 30.7466C30.9845 30.642 31.3702 30.372 32.1416 29.8321L41.6673 23.1641M23.934 38.3307H36.0673C38.0275 38.3307 39.0076 38.3307 39.7563 37.9493C40.4149 37.6137 40.9503 37.0783 41.2858 36.4197C41.6673 35.671 41.6673 34.6909 41.6673 32.7307V25.2641C41.6673 23.3039 41.6673 22.3238 41.2858 21.5751C40.9503 20.9165 40.4149 20.3811 39.7563 20.0455C39.0076 19.6641 38.0275 19.6641 36.0673 19.6641H23.934C21.9738 19.6641 20.9937 19.6641 20.245 20.0455C19.5865 20.3811 19.051 20.9165 18.7155 21.5751C18.334 22.3238 18.334 23.3039 18.334 25.2641V32.7307C18.334 34.6909 18.334 35.671 18.7155 36.4197C19.051 37.0783 19.5865 37.6137 20.245 37.9493C20.9937 38.3307 21.9738 38.3307 23.934 38.3307Z"
                            stroke="#344054"
                            strokeWidth="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </g>
                    <defs>
                        <filter
                            id="filter0_d_3752_2008"
                            x="0"
                            y="0"
                            width="60"
                            height="60"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                        >
                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                            />
                            <feOffset dy="1" />
                            <feGaussianBlur stdDeviation="1" />
                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                            />
                            <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_3752_2008"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_3752_2008"
                                result="shape"
                            />
                        </filter>
                    </defs>
                </svg>
            </div>
            <h2 className="forgot-title text-center">Email Verified</h2>
            <p className="text-center">You can now login with your email <br /><strong>{email}</strong></p>
            <form>
                <div class="don-have-account mt-4 mb-4">

                    <p className="" style={{ marginLeft: "130px", marginRight: "130px" }} >
                        <button
                            className={`default-btn signinBtn mt-4 ${isLoading ? "isLogin" : ""
                                }`}
                            onClick={()=>{
                                navigate(`/login`)
                            }}    
                        >
                            {isLoading ? (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            ) : (
                                t("Continue")
                            )}
                        </button>
                    </p>

                </div>
            </form>
            {false && <div className="bying-brokarage">Buying for your brokerage, instead?</div> }
        </div>
    </>)
}
export default EmailVerifiedSuccess;